import { render, staticRenderFns } from "./addchild.vue?vue&type=template&id=4d81b3fb&scoped=true"
import script from "./addchild.vue?vue&type=script&lang=js"
export * from "./addchild.vue?vue&type=script&lang=js"
import style0 from "./addchild.vue?vue&type=style&index=0&id=4d81b3fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d81b3fb",
  null
  
)

export default component.exports